import { createSelector } from "reselect";

export const assetLeadIdParamSelector = createSelector(
  (state) => state.router && state.router.location,
  (location) => {
    if (!location) {
      return null;
    }

    const match = location.pathname.match(/^\/asset_leads\/(\d+)/);

    if (match) {
      return parseInt(match[1], 10);
    }

    return null;
  }
);

export const isAssetDetail = createSelector(
  (state) => state.router.location,
  (location) => !!location.pathname.match(/^\/assets\/(?:\d+)/)
);

export const isAssetDetailSpaces = createSelector(
  (state) => state.router.location,
  (location) => !!location.pathname.match(/^\/assets\/(?:\d+)\/spaces/)
);

export const isAssetIndex = createSelector(
  (state) => state.router.location,
  (location) => !!location.pathname.match(/^\/assets[^/]?$/)
);

export const isAssetLeadIndex = createSelector(
  (state) => state.router.location,
  (location) => !!location.pathname.match(/^\/asset_leads[^/]?$/)
);

export const isAssetLeadDetail = createSelector(
  (state) => state.router.location,
  (location) => !!location.pathname.match(/^\/asset_leads\/(?:\d+)/)
);

export const isCalendar = createSelector(
  (state) => state.router.location,
  (location) => !!location.pathname.match(/^\/calendar/)
);

export const isCompanyPage = createSelector(
  (state) => state.router.location,
  (location) => !!location.pathname.match(/^\/companies\/(?:.+)/)
);

export const isDealDetail = createSelector(
  (state) => state.router.location,
  (location) => !!location.pathname.match(/^\/deals\/(?:\d+)/)
);

export const isDealIndex = createSelector(
  (state) => state.router.location,
  (location) => !!location.pathname.match(/^\/deals[^/]?$/)
);

export const isFlyer = createSelector(
  (state) => state.router.location,
  (location) => !!location.pathname.match(/^\/flyers\/(?:\d+)/)
);

export const isInactiveUserSubscriptions = createSelector(
  (state) => state.router.location,
  (location) => !!location.pathname.match(/^\/settings\/subscriptions/)
);

export const isSettings = createSelector(
  (state) => state.router.location,
  (location) => !!location.pathname.match(/^\/settings.*/)
);

export const isDashboard = createSelector(
  (state) => state.router.location,
  (location) => !!location.pathname.match(/^\/dashboard/)
);

export const hasBackButton = createSelector(
  isAssetDetail,
  isAssetLeadDetail,
  isCalendar,
  isDealDetail,
  isSettings,
  isDashboard,
  (...args) => args.some((x) => x)
);
